import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clinicprocedure',
  templateUrl: './clinicprocedure.component.html',
  styleUrls: ['./clinicprocedure.component.css']
})
export class ClinicprocedureComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
